<template>
    <div>
        <div>
            <span class="timeline-key">Old Visa Details </span>: {{extra.old_visa_number}} ({{extra.old_start_date}} to {{extra.old_expiry_date}})<br>
            <span class="timeline-key">File (if any) </span> : <file-display :src="extra.file"> </file-display> <br>

        </div>

    </div>
</template>

<script>
    import FileDisplay from "../../FileDisplay";
    export default {
        name: "VisaInfoUpdated",
        components: {FileDisplay},
        props: ['extra', 'user'],
        computed: {
        },
        mounted() {
            // console.log(this.extra);
        }
    }
</script>
